<template>
  <div class="food-search-dialog">
    <mu-content-block class="blueHeader">
      <mu-flexbox>
        <mu-flexbox-item>
          {{title}}
        </mu-flexbox-item>
        <mu-flexbox-item align="right">
          <md-icon
            style="cursor: pointer"
            slot="default"
            @click.native="closeDialog('addFoodDialog')"
            v-text="'close'"
          >
          </md-icon>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>
    <mu-content-block style="margin-top: 8px">
      <mu-paper class="search-area">
        <mu-flexbox style="height: 100%" align="center">
          <mu-flexbox-item grow="7" shrink="7">
            <mu-text-field
              icon="search"
              :hintText="$t('message.searchText')"
              :underlineShow="false"
              hintTextClass="hidden"
              v-model.lazy="searchValue"
              fullWidth
            ></mu-text-field>
          </mu-flexbox-item>
          <mu-flexbox-item shrink="1" align="right" v-if="voiceSupported">
            <mu-icon-button icon="keyboard_voice" @click.native="startVoiceRecognition"></mu-icon-button>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-paper>
    </mu-content-block>
    <div class="scrollable-area">

      <transition name="fade" mode="in-out">
        <mu-flexbox v-if="isSearching" align="center" justify="center" style="height: 100%">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="24"></mu-circular-progress>
            <br/>
            <span v-text="$t('message.loadingText')"></span>
          </mu-flexbox-item>
        </mu-flexbox>
      </transition>
      <transition name="fade" mode="in-out">
        <mu-flexbox v-if="isListening" align="center" justify="center" style="height: 100%">
          <div class="load-wrapp">
            <div class="load-3 bottom">
              <div class="line loaderRed"></div>
              <div class="line loaderGreen"></div>
              <div class="line loaderBlue"></div>
            </div>
            <div class="bottom">
              {{$t('message.labelVoiceRecognition')}}
            </div>
            <mu-raised-button label="Stop" @click.native="stopVoiceRecognition()"></mu-raised-button>
          </div>
        </mu-flexbox>
      </transition>

      <mu-list v-if="!isListening" class="oddEven">
        <mu-list-item
          disableRipple
          v-for="suggestion, index in suggestions"
          :key="'suggestion-' + index "
          @click.native="handleSelection(suggestion)"
        >
          <mu-icon slot="left" value="search"></mu-icon>
          <div slot="title" v-html="$sanitize(highlight(suggestion))" v-once></div>
        </mu-list-item>
      </mu-list>
    </div>
  </div>
</template>
<script>

  import FoodApi from '../../../api/Food';
  import {Observable} from 'rxjs';

  export default {
    name: 'fd-autocomplete-dialog',
    props: {
      searchTerm: {
        type: String,
        default: ""
      },
      title: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        voiceSupported: false,
        recognition: null,
        isListening: false,
        isSearching: false,
        searchValue: "",
        suggestions: []
      }
    },
    watch: {
      'searchValue': function () {
        if (this.searchValue === "") {
          this.suggestions = [];
        }
      }
    },
    mounted() {
      let self = this;
      self.searchValue = self.searchTerm;

      if (self.searchTerm !== "") {
        self.autoComplete();
      }


      self.initVoiceRecognition();


      self.initScrollFix();
      $(window).resize(function () {
        self.initScrollFix();
      });

      const autoCompleteElement = $('.mu-paper.search-area .mu-text-field-input');
      const observableConditionElement = Observable.fromEvent(autoCompleteElement, 'keydown').map(x => x);
      const delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
      delayedSearch.subscribe(function (e) {
        if (e.key === "Enter") {
          self.handleSelection(self.searchValue);
        }
        if (self.searchValue !== "") {
          self.autoComplete()
        }
      });
    },
    methods: {
      initVoiceRecognition() {
        let self = this,
          isSupported = (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition);
        if (isSupported !== undefined) {

          self.voiceSupported = true;
          self.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition)();
          self.recognition.lang = 'en-GB';
          self.recognition.interimResults = false;
          self.recognition.maxAlternatives = 5;

          self.recognition.onaudiostart = function (event) {
            self.isListening = true;
          };

          self.recognition.onaudioend = function (event) {
            self.isListening = false;
          };

          self.recognition.onresult = function (event) {
            if (typeof(event.results) === 'undefined') {
              recognition.stop();
              return;
            }
            for (let i = event.resultIndex; i < event.results.length; ++i) {
              if (event.results[i].isFinal) {
                self.searchValue = event.results[i][0].transcript;
                self.autoComplete();
                self.isListening = false;
              } else {
                self.searchValue = event.results[i][0].transcript;
                self.autoComplete();
                self.isListening = false;
              }
            }
          };
        }
        else {
          self.voiceSupported = false;
        }
      },
      startVoiceRecognition() {
        let self = this;
        if (!self.isListening) {
          self.isListening = true;
          self.recognition.start();
        }
        else {
          self.recognition.stop();
        }
      },
      stopVoiceRecognition() {
        let self = this;
        if (self.isListening === true) {
          self.isListening = false;
          self.recognition.stop();
        }
      },
      initScrollFix() {
        let headerHeight = $('.add-food-dialog .blueHeader').outerHeight();
        let searchHeight = $('.add-food-dialog .mu-content-block').outerHeight();
        let panelHeight = $('.add-food-dialog').outerHeight();
        let scrollHeight = panelHeight - (searchHeight + headerHeight) - 8;
        $('.food-search-dialog .scrollable-area').attr('style', 'height:' + scrollHeight + 'px;');
      },
      handleSelection(food) {
        let self = this;
        self.$emit('foodNameSelected', 's', food);
      },
      highlight(word) {
        let self = this;
        return word.replace(self.searchValue.toLowerCase(), '<span class=\'highlight\'>' + self.searchValue.toLowerCase() + '</span>')
      },
      autoComplete() {
        let self = this;
        self.isSearching = true;
        self.suggestions = [];
        FoodApi.autoComplete(self.searchValue)
          .then(function (response) {
            self.suggestions = response.data;
            self.isSearching = false;
          })
      },
      closeDialog() {
        this.$emit('closeDialog')
      }
    }
  }
</script>
<style>

  .load-wrapp {
    width: auto !important;
    height: auto !important;
    text-align: center;
  }

  .load-wrapp p {
    padding: 0 0 20px;
  }

  .load-wrapp:last-child {
    margin-right: 0;
  }

  .load-3 .line:nth-last-child(1) {
    animation: loadingC .6s .1s linear infinite;
  }

  .load-3 .line:nth-last-child(2) {
    animation: loadingC .6s .2s linear infinite;
  }

  .load-3 .line:nth-last-child(3) {
    animation: loadingC .6s .3s linear infinite;
  }

  .load-wrapp .line {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
  }

  .loaderRed {
    background: #F58923 !important;
  }

  .loaderGreen {
    background: #7CBE30 !important;
  }

  .loaderBlue {
    background: #0179d5 !important;
  }

  @keyframes loadingC {
    0% {
      transform: translate(0, 0);
    }
    50% {
      transform: translate(0, 15px);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  .food-search-dialog .scrollable-area {
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .food-search-dialog .mu-paper .mu-text-field-content {
    padding-top: 8px;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }

  .food-search-dialog .mu-paper .mu-text-field {
    min-height: initial;
  }

  .food-search-dialog .search-area {
    padding-left: 0px;
    padding-right: 16px;
    margin-top: -8px;
    margin-left: -8px;
    margin-right: -8px;
  }

  .add-food-dialog .labelBelowImg {
    margin-top: 8px;
    font-weight: 400;
  }

  @media (min-width: 993px) {
    .add-food-dialog .row .desktop-50 {
      width: calc((100% - 24px * 1) / 2) !important;
    }
  }

  .add-food-dialog .highlight {
    font-weight: 500;
    color: #0179d5;
  }

  .removePadding .mu-card-header-title {
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// AutocompleteDialog.vue?79c94384